<template>
<div class="chapter">
<div class="inner_page">
<h1 id="sigil_toc_id_4" title="PART 1: Critical Context">Part 1</h1>
<h2 class="sigil_not_in_toc">Critical Contexts</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pt1.vue?1a609770